module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_12 (19).7eb6691.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_12 (19).mp4
// module id = 794
// module chunks = 1